/**
 * Feature flags are set during ACC deployment via runtime deployer variables.
 * E.g. RD_FF_EXAMPLE_FEATURE => FeatureFlag.EXAMPLE_FEATURE
 */
export enum FeatureFlag {
  EXAMPLE_FEATURE = 'EXAMPLE_FEATURE', // JIRA-000
  SERVICE_DETECTION = 'SERVICE_DETECTION', // AC-280
  SUPPORT_TOOLS = 'SUPPORT_TOOLS', // AC-509
  USER_DASHBOARD = 'USER_DASHBOARD', // AC-519
  SUDO_DASHBOARD = 'SUDO_DASHBOARD', // AC-520
}
